import React, { useState } from 'react';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import PasswordField from '../../../../../Base/Components/Inputs/PasswordField/PasswordField';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
import apiClient from '../../../../../../Services/ApiClient';
import { useManagerContext } from '../../../../Services/ManagerContext';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
// @ts-ignore
import styles from './ManagerCertificateUploadWizardPasswordEntry.module.scss';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import Text from '../../../../../../Components/Base/Text/Text';
import Loading from '../../../../../../Components/Loading';
import useTranslation from '../../../../../../Hooks/useTranslation';

interface Props {
	certificateId: string;
	onSuccess: () => void;
}

const ManagerCertificateUploadWizardPasswordEntry: React.FC<Props> = ({
	certificateId,
	onSuccess,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const { rootWorkplaceId } = useManagerContext();
	const { displayError } = useApiClient();
	const { t } = useTranslation();

	const validationSchema = yup.object({
		password: yup
			.string()
			.required(
				t('validation.managerCertificateUploadWizardPasswordEntry.password'),
			),
	});

	const formMethods = useForm({ resolver: yupResolver(validationSchema) });

	const handleSkipPassword = () => {
		onSuccess();
	};

	const handleSubmit = async (vals: any) => {
		setIsLoading(true);
		const values: { password: string } = vals;

		try {
			const response = await apiClient.put(
				`/workplaces/${rootWorkplaceId}/certificate/${certificateId}`,
				{
					password: values.password,
					isCertificatePasswordless: false,
				},
			);
			if (response.status === 200) {
				onSuccess();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div>
			<FormWrapper formMethods={formMethods}>
				<Text
					className={styles.alert}
					tx='component.certificates.pswWillBeSaved'
				/>
				<PasswordField
					name='password'
					label='component.certificates.enterPsw'
					isRequired
				/>
				<div className={styles.buttons}>
					<SubmitButton onSubmit={handleSubmit} title='base.shared.continue' />
					<LinkButton
						title='component.certificates.commerce.step2.skipText'
						theme={Theme.BLUE}
						onClick={handleSkipPassword}
					/>
				</div>
			</FormWrapper>
		</div>
	);
};

export default ManagerCertificateUploadWizardPasswordEntry;
